import { Constants } from '../constants'

const initialState = {
    coins: {},
    transaction: {},
    payload: {},
    paymentStatus: 'success'
}

function paymentReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.GET_SUPPORTED_COINS_SUCCESS:
            return {
                ...state,
                coins: { ...action.payload },
                payload: { ...action.payload }
            }
        case Constants.DEPOST_POST_SUCCESS:
            return {
                ...state,
                transaction: { ...action.payload },
                paymentStatus: action.payload.status,
                payload: { ...action.payload }
            }
        case Constants.DEPOST_STATUS_SUCCESS:
            return {
                ...state,
                paymentStatus: action.payload.status,
                payload: { ...action.payload }
            }
        case 'CANCEL_TRANSACTION':
            return {
                ...state,
                paymentStatus: 'cancel'
            }
        case Constants.PAYMENT_WITHDRAW_SUCCESS:
        case Constants.CREATE_AKOLADE_SUCCESS:
        case Constants.GET_SUPPORTED_COINS_FAILURE:
        case Constants.DEPOST_POST_FAILURE:
        case Constants.DEPOST_STATUS_FAILURE:
        case Constants.PAYMENT_WITHDRAW_FAILURE:
        case Constants.CREATE_AKOLADE_FAILURE:
        case Constants.GET_USER_BALANCE_SUCCESS:
        case Constants.GET_USER_BALANCE_FAILURE:
        case Constants.GET_TOKEN_HISTORY_SUCCESS:
        case Constants.GET_TOKEN_HISTORY_FAILURE:
        case Constants.REVOKE_REFRESH_TOKEN_SUCCESS:
        case Constants.REVOKE_REFRESH_TOKEN_FAILURE:
            return {
                ...state,
                payload: { ...action.payload }
            }
        case Constants.LOGOUT:
            return initialState
        default:
            return state
    }
}

export default paymentReducer
